import _ from 'lodash'

import React, { Component } from 'react'
import { formValueSelector, clearFields } from 'redux-form'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import { listMainAreas } from '../actions/main-area'
import { setDefectAreaErrors, clearDefectAreaErrors, createDefectArea } from '../actions/defect-area'
import { clearProjectKey, listProjects } from '../actions/project'
import DefectAreaAdd from '../components/DefectAreaAdd'

class DefectAreaAddPage extends Component {
    componentDidMount () {
        const { clearMainAreaErrors, listMainAreas, listProjects, clearProjectKey } = this.props
        clearMainAreaErrors()
        listProjects({ limit: -1 })
        // listMainAreas({ limit: -1 })
    }

    render () {
        return (<DefectAreaAdd {...this.props}/>)
    }
}

const selector = formValueSelector('defect-area-add')

const mapStateToProps = (state, ownProps) => {
    const projects = _.get(state, 'project.project.list.rows', [])
    const mainAreas = _.get(state, 'mainArea.mainArea.list.rows', [])
    const props = {
        errors: _.get(state, 'defectArea.errors', {}),
        mainAreas,
        mainAreaId: selector(state, 'mainAreaId'),
        projects,
        projectId: selector(state, 'projectId')
    }
    return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    async onSubmit (values) {
        const errors = {}
        if (!values.mainAreaId) {
            errors.mainAreaId = 'Main area is required.'
        }
        if (!values.name) {
            errors.name = 'Main area name is required.'
        }
        if (!_.isEmpty(errors)) {
            dispatch(setDefectAreaErrors(errors))
            return
        }
        dispatch(clearDefectAreaErrors())
        await dispatch(createDefectArea({
            ...values
        }))
        dispatch(push('/defectArea'))
    },
    clearMainAreaErrors() {
        dispatch(clearDefectAreaErrors())
    },
    listMainAreas (query) {
        dispatch(listMainAreas(query, 'mainArea'))
    },
    goBack () {
        dispatch(goBack())
    },
    listProjects (query) {
        dispatch(listProjects(query, 'project'))
    },
    async onProjectChanged (event, projectId) {
        await dispatch(listMainAreas({ projectId, limit: -1 }, 'mainArea'))
        dispatch(clearFields('defect-list', false, false, 'mainAreaId', 'defectAreaId'))
      }
})

export default connect(mapStateToProps, mapDispatchToProps)(DefectAreaAddPage)


// WEBPACK FOOTER //
// ./src/containers/DefectAreaAddPage.js